module.exports = __webpack_public_path__ + "img/20190531170916微信截图_20190531171119.8a0d05b4.png";